import { createContext, Dispatch, SetStateAction } from 'react'

import { OrganisationConfiguration } from 'context/materialUI/types'

export const FormContext = createContext<{
	localForm: OrganisationConfiguration
	formEdited: boolean
	setFormEdited: Dispatch<SetStateAction<boolean>>
	setLocalForm: Dispatch<SetStateAction<OrganisationConfiguration>>
}>(null)
